import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { backgroundColor, borderRadius } from 'styled-system';

import { useLocalization } from 'common/providers/LocaleProvider';
import { Flex } from './Flex';
import { Text } from './Text';

const UnstyledEcoFriendlyBox = styled(Flex)<any>`
  ${borderRadius};
  ${backgroundColor};
`;

const EcoFriendlyBox = (props: ComponentProps<typeof UnstyledEcoFriendlyBox>) => (
  <UnstyledEcoFriendlyBox
    mb="sp_8"
    px={['sp_4', null, null, 'sp_8']}
    borderRadius="small"
    width="fit-content"
    backgroundColor="sys.success.background.hover"
    {...props}
  />
);

const UnstyledEcoFriendlyText = styled(Text)``;

const EcoFriendlyText = (props: ComponentProps<typeof UnstyledEcoFriendlyText>) => (
  <UnstyledEcoFriendlyText
    color="sys.neutral.background.default"
    fontWeight="bold"
    fontSize={['fs_12', 'fs_16', null, 'fs_18']}
    lineHeight={['lh_16', 'lh_20', null, 'lh_22']}
    {...props}
  />
);

const EcoFriendlyLabel = () => {
  const { t } = useLocalization();

  return (
    <EcoFriendlyBox>
      <EcoFriendlyText>{t('h24_reclamation_eco_friendly_label')}</EcoFriendlyText>
    </EcoFriendlyBox>
  );
};

export default EcoFriendlyLabel;
